import classNames from "classnames";
import styles from "./index.module.less";
import { useEffect, useMemo, useState } from "react";
import { Button, Checkbox, Empty, Flex, Input, Pagination, Radio } from "antd";
import SearchIcon from "./imgs/search.svg?react";
import JobCard from "./components/JobCard";
import { useSetState } from "ahooks";
import EmptyIcon from "@/assets/imgs/empty.svg?react";
import JobDetail from "./components/JobDetail";
import { JobDto, tabs } from "../constant";
import SVGIcon from "@/components/SVGIcon";
import UploadResumeModel from "@/components/UploadResumeModel";
import EmailModal from "@/components/EmailModal";
import P1Content from "@/components/P1Content";
import MobileModal from "../../../components/MobileModal";
import banner from "./imgs/p1_bg.png";
import ArrowDownIcon from "@/assets/imgs/arrow_down.svg?react";
// import ArrowUpIcon from "./imgs/arrow_up.svg?react";
const PAGE_SIZE = 10;
const MobileJoinUs = () => {
  const [activeTab, setActiveTab] = useState("social");
  const [query, setQuery] = useState("");
  const jobs = useMemo(() => {
    return tabs.find((tab) => tab.value === activeTab)?.jobs || [];
  }, [activeTab]);
  const [pageState, setPageState] = useSetState({
    search: "",
    categories: [] as string[],
    locations: [] as string[],
    page: 1,
    pageSize: PAGE_SIZE,
  });
  const categories = jobs
    .map((job) => job.category)
    .filter((v, i, a) => a.indexOf(v) === i);
  const locations = jobs
    .map((job) => job.locations)
    .flat()
    .filter((v, i, a) => a.indexOf(v) === i);
  const list = useMemo(() => {
    return jobs.filter((job) => {
      const matchCategory = pageState.categories.length
        ? pageState.categories.includes(job.category)
        : true;
      const matchLocation = pageState.locations.length
        ? job.locations.some((location) =>
            pageState.locations.includes(location)
          )
        : true;
      const matchSearch = job.title.includes(pageState.search);
      return matchCategory && matchLocation && matchSearch;
    });
  }, [pageState, jobs]);
  const slicedList = useMemo(() => {
    return list.slice(
      (pageState.page - 1) * pageState.pageSize,
      pageState.page * pageState.pageSize
    );
  }, [list, pageState]);
  const [detail, setDetail] = useState<any>(null);

  const [visible, setVisible] = useState(false);
  const [openCategorySelector, setOpenCategorySelector] = useState(false);
  const [openLocationSelector, setOpenLocationSelector] = useState(false);

  useEffect(() => {
    if (detail) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [detail]);
  return (
    <div className={styles.joinUs}>
      <div className={styles.p1}>
        <P1Content
          title="加入我们"
          subtitle="与我们一起，塑造下一代数字员工"
          showBtn={false}
          style={{
            backgroundImage: `url(${banner})`,
          }}
        />
      </div>
      <div className={styles.p2}>
        <div className={styles.tabs}>
          {tabs.map((tab) => (
            <div
              key={tab.value}
              className={classNames(styles.tab, {
                [styles.active]: tab.value === activeTab,
              })}
              onClick={() => {
                setActiveTab(tab.value);
                setPageState({
                  search: "",
                  categories: [],
                  locations: [],
                  page: 1,
                  pageSize: PAGE_SIZE,
                });
                setQuery("");
                setDetail(null);
              }}
            >
              {tab.label}
            </div>
          ))}
        </div>
        <div className={styles.p2_inner}>
          <Flex
            // align="center"
            // justify="space-between"
            className={styles.p2_toolbar}
            vertical
          >
            <div className={styles.p2_title}>
              在招职位
              <span style={{ color: "#AAABB2" }}>({list.length})</span>
            </div>
            <Input
              value={query}
              onChange={(e) => {
                setQuery(e.target.value);
                if (!e.target.value) {
                  setPageState({ page: 1, search: "" });
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setPageState({ page: 1, search: query });
                  setDetail(null);
                }
              }}
              placeholder="请输入职位关键词"
              prefix={<SVGIcon icon={<SearchIcon />} />}
              className={styles.p2_input}
            />
          </Flex>
          {detail ? (
            <>
              <JobDetail
                onReturn={() => setDetail(null)}
                data={detail}
                onSubmit={() => setVisible(true)}
              />
            </>
          ) : (
            <Flex vertical>
              <Flex gap={".12rem"} className={styles.selectors}>
                <div
                  className={classNames(styles.selector, {
                    [styles.active]: !!pageState.categories.length,
                  })}
                  onClick={() => {
                    setOpenCategorySelector(true);
                    setOpenLocationSelector(false);
                  }}
                >
                  职位类别
                  {pageState.categories.length
                    ? `(${pageState.categories.length})`
                    : null}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                  >
                    <path
                      d="M1.33301 2.66669L3.99967 5.33335L6.66634 2.66669"
                      stroke="#666A80"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div
                  className={classNames(styles.selector, {
                    [styles.active]: !!pageState.locations.length,
                  })}
                  onClick={() => {
                    setOpenLocationSelector(true);
                    setOpenCategorySelector(false);
                  }}
                >
                  工作地点
                  {pageState.locations.length
                    ? `(${pageState.locations.length})`
                    : null}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                  >
                    <path
                      d="M1.33301 2.66669L3.99967 5.33335L6.66634 2.66669"
                      stroke="#666A80"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </Flex>
              <div
                className={classNames(styles.positions, {
                  [styles.noData]: list.length === 0,
                })}
              >
                {list.length === 0 && (
                  <Empty
                    className={styles.noData}
                    image={<EmptyIcon />}
                    description="暂无数据"
                  />
                )}
                {slicedList.map((job, index) => (
                  <JobCard
                    key={index}
                    data={job}
                    onClick={() => {
                      setDetail(job);
                    }}
                  />
                ))}
                {list.length > 0 && (
                  <Pagination
                    size="small"
                    className={styles.pagination}
                    total={list.length}
                    current={pageState.page}
                    pageSize={pageState.pageSize}
                    onChange={(page, pageSize) =>
                      setPageState({ page, pageSize })
                    }
                  />
                )}
              </div>
            </Flex>
          )}
        </div>
      </div>
      <EmailModal visible={visible} onClose={() => setVisible(false)} />

      <MobileModal
        title="职位类别"
        open={openCategorySelector}
        onClose={() => setOpenCategorySelector(false)}
      >
        <Checkbox.Group
          className={styles.checkboxGroup}
          value={pageState.categories}
          onChange={(values) =>
            setPageState({ categories: values as string[], page: 1 })
          }
          options={categories.map((category) => ({
            label: category,
            value: category,
          }))}
        />
      </MobileModal>
      <MobileModal
        title="工作地点"
        open={openLocationSelector}
        onClose={() => setOpenLocationSelector(false)}
      >
        <Checkbox.Group
          className={styles.checkboxGroup}
          value={pageState.locations}
          onChange={(values) =>
            setPageState({ locations: values as string[], page: 1 })
          }
          options={locations.map((location) => ({
            label: location,
            value: location,
          }))}
        />
      </MobileModal>
    </div>
  );
};
export default MobileJoinUs;
